import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';

export interface ICashFlowStatementTotalTableEntry {
    totalIndex: string;
    totalName: string | IDynamicKeyValue;
    currentTotal: number | null;
    previousTotal: number | null;
    // optional because not all entries are flis
    fliId?: string;
}
